import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import api from '../lib/api.js';

export function useMe() {
  const navigate = useNavigate();

  const query = useQuery({
    queryKey: ['me'],
    queryFn: () => api.get('/auth/me'),
    retry: false,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (query.error?.status === 401) {
      navigate('/login', { replace: true });
    }
  }, [query.error, navigate]);

  return query;
}
